import { Hooper, Slide, Pagination as HooperNavigation } from 'hooper';

  export default {
    name: 'HomeSlider',
    components: {
      Hooper,
      Slide
    },
    watch: {
      carouselData () {
        this.$refs.carousel.slideTo(this.carouselData);
      }
    },
    methods: {
      slidePrev() {
        this.$refs.carousel.slidePrev();
      },
      slideNext() {
        this.$refs.carousel.slideNext();
      },
      updateCarousel(payload) {
        this.myCarouselData = payload.currentSlide;
      }
    }
  }